module.exports = __webpack_public_path__ + "static/media/Journey of the Fearless.d9bbfb4e.jpg";